if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.options = JSON.parse(this.getAttribute('data-swiper-options') || '{}');
      this.wrapper = this.querySelector('.swiper-wrapper');
      this.slides = [...this.wrapper.children];
      this.index = 0;
      this.pointerStart = null;
      this.paused = false;
      this.media = matchMedia('(min-width: 750px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.setAttribute('data-native-slider', '');
      this.refresh();
      this.media.addEventListener('change', () => this.refresh(), { signal });
      this.motion.addEventListener('change', () => this.refresh(), { signal });
      this.addEventListener('pointerenter', () => this.pause(), { signal });
      this.addEventListener('pointerleave', () => this.resume(), { signal });
      this.addEventListener('focusin', () => this.pause(), { signal });
      this.addEventListener('focusout', e => {
        if (!this.contains(e.relatedTarget)) this.resume();
      }, { signal });
      this.addEventListener('pointerdown', e => { this.pointerStart = e.clientX; }, { signal, passive: true });
      this.addEventListener('pointerup', e => {
        if (this.pointerStart === null) return;
        const distance = this.pointerStart - e.clientX;
        this.pointerStart = null;
        if (Math.abs(distance) > 40) this.advance(distance > 0 ? 1 : -1);
      }, { signal, passive: true });
      this.addEventListener('pointercancel', () => { this.pointerStart = null; }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.start();
      }, { signal });
    }

    refresh() {
      this.perView = this.media.matches ? (this.options.slidesPerViewDesktop || 1) : (this.options.slidesPerView || 1);
      if (typeof this.perView !== 'number') this.perView = this.slides.length;
      this.perView = Math.max(1, Math.min(this.perView, this.slides.length));
      this.index = Math.min(this.index, Math.max(0, this.slides.length - this.perView));
      this.style.setProperty('--announcement-slides-per-view', this.perView);
      this.show();
      this.start();
    }

    show() {
      const direction = getComputedStyle(this).direction === 'rtl' ? 1 : -1;
      this.wrapper.style.transform = `translateX(${direction * this.index * 100 / this.perView}%)`;
      this.slides.forEach((slide, index) => {
        const hidden = index < this.index || index >= this.index + this.perView;
        slide.setAttribute('aria-hidden', String(hidden));
        slide.inert = hidden;
      });
    }

    advance(step) {
      const maximum = Math.max(0, this.slides.length - this.perView);
      if (!maximum) return;
      const next = this.index + step;
      const loop = this.media.matches ? (this.options.loopDesktop ?? this.options.loop) : this.options.loop;
      this.index = loop ? (next + maximum + 1) % (maximum + 1) : Math.max(0, Math.min(next, maximum));
      this.show();
    }

    start() {
      this.stop();
      if (!this.options.autoplay || this.motion.matches || this.paused || document.hidden || this.perView >= this.slides.length) return;
      const delay = Math.max(1000, Number(this.options.autoplay.delay) || 5000);
      this.timer = setInterval(() => this.advance(1), delay);
    }

    stop() { clearInterval(this.timer); }
    pause() { this.paused = true; this.stop(); }
    resume() { this.paused = false; this.start(); }

    disconnectedCallback() {
      this.stop();
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
